export namespace DriverBankTransactionTypeConstants {
  export const CREDIT = 'credit';
  export const DEBIT = 'debit';
}
